export default [
	{ label: 'Início', link: '/' },
	{ label: 'Mapas interativos', link: '/map' },
	{ label: 'Emissão de documentos', link: '/services' },
	{ label: 'Downloads', link: '/downloads' },
	{
		label: 'Download mapa Físico Político',
		link: '/downloads/mapa_fisico_politico',
	},
	{ label: 'Download Ambiental', link: '/downloads/ambiental' },
	{ label: 'Download Cadastro', link: '/downloads/cadastro' },
	{ label: 'Download CENSO IBGE 2010', link: '/downloads/senso_ibge_2010' },
	{
		label: 'Download Limites políticos',
		link: '/downloads/limites_politicos',
	},
	{ label: 'Download Área urbanizada', link: '/downloads/area_urbanizada' },

	{
		label: 'Emissão de Documentos - Pré-Consulta para Fins de Construção',
		link: '/services/consulta-construcao',
	},
	{
		label: 'Emissão de Documentos - Memorial Descritivo',
		link: '/services/memorial-descritivo',
	},
	{
		label: 'Emissão de Documentos - Planta Quadra',
		link: '/services/planta-quadra',
	},
	{
		label: 'Emissão de Documentos - Certidão de Confrontantes',
		link: '/services/certidao-confrontantes',
	},
	{
		label:
			'Emissão de Documentos - Pré-consulta de Viabilidade para Instalação',
		link: '/services/consulta-instalacao',
	},

	{
		label: 'Artigos',
		link: '/article',
	},
	{
		label: 'Artigo Gestão Territorial',
		link: '/article/gestaoterritorial',
	},
	{
		label: 'Geoserviços',
		link: '/geoservices',
	},
];
